import { px2rem } from '../utils/helpers/style.js';

var getGapSize = function getGapSize(size) {
  return typeof size === 'number' ? px2rem(size) : size;
};
var isGapDimension = function isGapDimension(size) {
  return size.x !== undefined && size.y !== undefined;
};
var getGapDimensions = function getGapDimensions(size) {
  if (isGapDimension(size)) {
    return {
      x: getGapSize(size.x),
      y: getGapSize(size.y)
    };
  } else {
    return {
      x: getGapSize(size),
      y: getGapSize(size)
    };
  }
};

export { getGapDimensions };
